  var messageContainerNode = document.querySelector('.announcement_bar--multimessage');
  var messageItemNodes = messageContainerNode.querySelectorAll('.announcement_bar-text');
  messageContainerNode.classList.add("announcement_bar--multimessageLoaded");

  var activeMessageIndex = 0;

  /* Get HTML of items from initial DOM */
  var messageTextList = Array.from(messageItemNodes).map((item) => {
    return item.innerHTML.trim();
  });

  /* Remove all but active message from DOM */
  messageItemNodes.forEach(function(itemNode, index) {
    if (index != activeMessageIndex) {
      itemNode.remove();
    }
  });

  var animateCurrentMessageOut = () => {
    var currentMessage = messageContainerNode.querySelector('.announcement_bar-text');
    currentMessage.classList.add('announcement_bar-text--fadeOut');

    setTimeout(function() {
      currentMessage.remove();
    }, 625);
  }

  var createNewMessageNode = () => {
    /* increase index to determine which message to add in */
    activeMessageIndex += 1;

    /* If none is found, go back to start */
    var newMessageText = messageTextList[activeMessageIndex];
    if (!newMessageText) {
      newMessageText = messageTextList[0];
    }

    var newMessageNode = document.createElement("div");
    newMessageNode.classList.add("announcement_bar-text", "announcement_bar-text--new");
    newMessageNode.innerHTML = newMessageText;

    return newMessageNode;
  }

  var addNewMessage = () => {
    animateCurrentMessageOut();
    var newMessage = createNewMessageNode();
    messageContainerNode.appendChild(newMessage);

    setTimeout(function() {
      newMessage.classList.add("announcement_bar-text--fadeIn");
    }, 50);

    setTimeout(function() {
      newMessage.classList.remove("announcement_bar-text--new", "announcement_bar-text--fadeIn");
    }, 625);
  }


  setInterval(function() {
    addNewMessage();
  }, 6500);